import * as React from "react";
import * as ReactDOM from "react-dom";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import APIConnector from "../../../apiconnector";
import CommonVariables from "../../../variables";
import Notifications from "../../../Notifications/Messages";
import { Filter, Operators, TextFilter, NumericFilter, DateFilter } from "@progress/kendo-react-data-tools";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import RefreshIcon from '@mui/icons-material/Refresh';
import { GridPDFExport } from "@progress/kendo-react-pdf";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import PrintIcon from '@mui/icons-material/Print';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import { Input, NumericTextBox } from "@progress/kendo-react-inputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { formatDateOnly } from '../../../commonfunctions';
import { AccountCircle, TableChart } from "@mui/icons-material";
import ContactModal from "../Contact/ContactModal";
import {
    emptyContact,
    getContactId,
    mapContactResponse,
    buildTelephoneValue,
    phoneRegex
} from "../Contact/contactHelper";
/**
 * Account Component enables users to view, add, edit accounts, and manage contacts under an account.*
 */
const Account = (props) => {
    const unassignContactFromAccount = (contactId) => {
        return APIConnector.Post(CommonVariables.urls.UpdateContact, {
            contactid: [contactId],
            columnnames: [
                "parentCustomerId"
            ],
            recordId: contactId,
            parentCustomerId: "00000000-0000-0000-0000-000000000000"
        });
    };
    const emptyAccount = {
        accountId: "",
        primarycontactid: "",
        primarycontactname: "",
        name: "",
        accountnumber: "",
        tt_statementname: "",
        tt_grades: "",
        tt_SalesCoordinatorId: "",
        tt_salescoordinatorid: "",
        tt_salesrepid: "",
        tt_SalesRepId: "",
        parentaccountid: null,
        emailaddress1: "",
        tt_status_number: 206340006,
        account_category_code: 206340001,
        address1_line3: "",
        postal_code: "",
        address1_telephone1: "",
        tt_StatementName: "",
        tt_stateprovinceid: "",
        tt_programschedulecomplete: false,
        tt_GPUpdateFlag: false,
        tt_taxexemptinfo: "",
        tt_taxexcemptexpirationdate: "",
        customertypecode: "",
        address1_line2: "",
        address1_line1: "",
        address1_stateorprovince: "",
        address1_name: "",
        address1_county: "",
        address1_city: "",
        salescoordinatoremailaddress: "",
        salescoordinatorname: "",
        salesrepemailaddress: "",
        salesrepid: "",
        tt_SalesRepId: "",
        salesrepname: "",
        schoolemailaddress: "",
        gpAccountLoaded: false
    };
    const accountCategoryCodeOptions = [
        { text: "Lead", value: 206340004 },
        { text: "Current School", value: 206340000 },
        { text: "New School", value: 206340001 }
    ];
    const accountStatusNumberOptions = [
        { text: "Prospect", value: 206340006 },
        { text: "Quoted", value: 206340003 },
        { text: "Contract", value: 206340004 },
        { text: "Declined", value: 206340005 }
    ];

    const defaultAccountCategoryCodeValue = 206340001;
    const defaultAccountStatusNumberValue = 206340006;

    const usStateOptions = [
        { code: "AL", name: "Alabama", text: "AL - Alabama" },
        { code: "AK", name: "Alaska", text: "AK - Alaska" },
        { code: "AZ", name: "Arizona", text: "AZ - Arizona" },
        { code: "AR", name: "Arkansas", text: "AR - Arkansas" },
        { code: "CA", name: "California", text: "CA - California" },
        { code: "CO", name: "Colorado", text: "CO - Colorado" },
        { code: "CT", name: "Connecticut", text: "CT - Connecticut" },
        { code: "DE", name: "Delaware", text: "DE - Delaware" },
        { code: "FL", name: "Florida", text: "FL - Florida" },
        { code: "GA", name: "Georgia", text: "GA - Georgia" },
        { code: "HI", name: "Hawaii", text: "HI - Hawaii" },
        { code: "ID", name: "Idaho", text: "ID - Idaho" },
        { code: "IL", name: "Illinois", text: "IL - Illinois" },
        { code: "IN", name: "Indiana", text: "IN - Indiana" },
        { code: "IA", name: "Iowa", text: "IA - Iowa" },
        { code: "KS", name: "Kansas", text: "KS - Kansas" },
        { code: "KY", name: "Kentucky", text: "KY - Kentucky" },
        { code: "LA", name: "Louisiana", text: "LA - Louisiana" },
        { code: "ME", name: "Maine", text: "ME - Maine" },
        { code: "MD", name: "Maryland", text: "MD - Maryland" },
        { code: "MA", name: "Massachusetts", text: "MA - Massachusetts" },
        { code: "MI", name: "Michigan", text: "MI - Michigan" },
        { code: "MN", name: "Minnesota", text: "MN - Minnesota" },
        { code: "MS", name: "Mississippi", text: "MS - Mississippi" },
        { code: "MO", name: "Missouri", text: "MO - Missouri" },
        { code: "MT", name: "Montana", text: "MT - Montana" },
        { code: "NE", name: "Nebraska", text: "NE - Nebraska" },
        { code: "NV", name: "Nevada", text: "NV - Nevada" },
        { code: "NH", name: "New Hampshire", text: "NH - New Hampshire" },
        { code: "NJ", name: "New Jersey", text: "NJ - New Jersey" },
        { code: "NM", name: "New Mexico", text: "NM - New Mexico" },
        { code: "NY", name: "New York", text: "NY - New York" },
        { code: "NC", name: "North Carolina", text: "NC - North Carolina" },
        { code: "ND", name: "North Dakota", text: "ND - North Dakota" },
        { code: "OH", name: "Ohio", text: "OH - Ohio" },
        { code: "OK", name: "Oklahoma", text: "OK - Oklahoma" },
        { code: "OR", name: "Oregon", text: "OR - Oregon" },
        { code: "PA", name: "Pennsylvania", text: "PA - Pennsylvania" },
        { code: "RI", name: "Rhode Island", text: "RI - Rhode Island" },
        { code: "SC", name: "South Carolina", text: "SC - South Carolina" },
        { code: "SD", name: "South Dakota", text: "SD - South Dakota" },
        { code: "TN", name: "Tennessee", text: "TN - Tennessee" },
        { code: "TX", name: "Texas", text: "TX - Texas" },
        { code: "UT", name: "Utah", text: "UT - Utah" },
        { code: "VT", name: "Vermont", text: "VT - Vermont" },
        { code: "VA", name: "Virginia", text: "VA - Virginia" },
        { code: "WA", name: "Washington", text: "WA - Washington" },
        { code: "WV", name: "West Virginia", text: "WV - West Virginia" },
        { code: "WI", name: "Wisconsin", text: "WI - Wisconsin" },
        { code: "WY", name: "Wyoming", text: "WY - Wyoming" }
    ];
    const accountFields = [
        {
            name: "name",
            label: "Account Name",
            filter: TextFilter,
            operators: Operators.text,
            width: "200",
        },
        {
            name: "accountnumber",
            label: "Account #",
            filter: TextFilter,
            operators: Operators.numeric,
            width: "120",
        },
        {
            name: "account_category_code_display",
            label: "Customer Status",
            filter: TextFilter,
            operators: Operators.text,
            width: "170",
        },
        {
            name: "tt_status_number_display",
            label: "Account Status",
            filter: TextFilter,
            operators: Operators.text,
            width: "170",
        },
        {
            name: "salesrepname",
            label: "Sales Rep",
            filter: TextFilter,
            operators: Operators.text,
            width: "180",
        },
        {
            name: "primarycontactname",
            label: "Primary Contact",
            filter: TextFilter,
            operators: Operators.text,
            width: "180",
        },
        {
            name: "tt_grades",
            label: "Grades",
            filter: TextFilter,
            operators: Operators.text,
            width: "120",
        },
        {
            name: "salescoordinatorname",
            label: "Sales Coordinator",
            filter: TextFilter,
            operators: Operators.text,
            width: "200",
        }
    ];

    const contactFields = [
        {
            name: "fullname",
            label: "Full Name",
            width: "150"
        },
        {
            name: "emailaddress1",
            label: "Email",
            width: "150"
        },
        {
            name: "mobilephone",
            label: "Mobile #",
            width: "120"
        },
        {
            name: "gpcontactid",
            label: "GP Contact ID",
            width: "130"
        },
        {
            name: "prospectyear",
            label: "Prospect Year",
            width: "130"
        },
        {
            name: "owner",
            label: "Owner",
            width: "130"
        },
        {
            name: "customerparent",
            label: "Customer / Parent",
            width: "150"
        }
    ];
    const renderContactColumns = () => contactFields.map((field) => (
        <Column
            key={field.name}
            field={field.name}
            title={field.label}
            width={field.width}
        />
    ));
    const contactGridWidth = contactFields.reduce((totalWidth, field) => (
        totalWidth + Number(field.width)
    ), 0);
    const accountGridFields = accountFields
        .filter((field) => field.name)
        .map(({ width, ...field }) => field);
    const renderAccountColumns = () => accountFields.map((field, index) => {
        if (!field.name) {
            return (
                <Column
                    key={`${field.label}-${index}`}
                    width={field.width}
                    title={field.label}
                    cell={() => <td></td>}
                />
            );
        }

        if (field.name === "account_category_code_display") {
            return (
                <Column
                    key={field.name}
                    field={field.name}
                    width={field.width}
                    title={field.label}
                    cell={(props) => (
                        <td>{getAccountCategoryCodeDisplayText(props.dataItem)}</td>
                    )}
                />
            );
        }

        if (field.name === "tt_status_number_display") {
            return (
                <Column
                    key={field.name}
                    field={field.name}
                    width={field.width}
                    title={field.label}
                    cell={(props) => (
                        <td>{getAccountStatusNumberDisplayText(props.dataItem)}</td>
                    )}
                />
            );
        }

        return (
            <Column
                key={field.name}
                field={field.name}
                width={field.width}
                title={field.label}
            />
        );
    });
    //#region " Initialization of State  Values       "
    const initialFilter = {
        logic: "and",
        filters: [{
            field: "name",
            operator: "contains",
            value: '',
        }]
    };
    const [filter, setFilter] = React.useState(initialFilter);
    const [sort, setSort] = React.useState([]);
    const [data, setData] = React.useState([]);
    const [showAddAccountDialog, setShowAddAccountDialog] = React.useState(false);
    const [newAccount, setNewAccount] = React.useState(emptyAccount);
    const [validationErrors, setValidationErrors] = React.useState({});
    const [isEditMode, setIsEditMode] = React.useState(false);
    const [editingAccountItem, setEditingAccountItem] = React.useState(null);
    const [accountContacts, setAccountContacts] = React.useState([]);
    const [showContactDialog, setShowContactDialog] = React.useState(false);
    const [newContact, setNewContact] = React.useState(emptyContact);
    const [contactValidationErrors, setContactValidationErrors] = React.useState({});
    const [isContactEditMode, setIsContactEditMode] = React.useState(false);
    const [editingContactItem, setEditingContactItem] = React.useState(null);
    const [deleteContactDialogOpen, setDeleteContactDialogOpen] = React.useState(false);
    const [deleteContactItem, setDeleteContactItem] = React.useState(null);
    const [salesCoordAndRepOptions, setsalesCoordAndRepOptions] = React.useState([]);
    const [primaryContactOptions, setPrimaryContactOptions] = React.useState([]);
    const getEmptyPrimaryContactDraft = () => ({
        ...emptyContact,
        telephoneNumber: "",
        address1_line1: "",
        address1_line2: "",
        address1_county: "",
        address1_city: "",
        tt_stateprovinceid: "",
        address1_stateorprovince: "",
        address1_postalcode: ""
    });
    const [isGpAccountLoaded, setIsGpAccountLoaded] = React.useState(false);
    const [showCreatePrimaryContactSection, setShowCreatePrimaryContactSection] = React.useState(false);
    const [primaryContactDraft, setPrimaryContactDraft] = React.useState(getEmptyPrimaryContactDraft());
    const toolbarButtonBorderColor = "#8b96c7";
    const toolbarButtonHoverBorderColor = "#574ea8";
    const toolbarButtonStyle = {
        marginLeft: "15px",
        marginBottom:"3px",
        font: "caption",
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        border: `1px solid ${toolbarButtonBorderColor}`,
        borderRadius: "4px",
        padding: "6px 8px",
        backgroundColor: "#ebefff",
        cursor: "pointer",
        lineHeight: "20px",
        verticalAlign: "middle"
    };
    const toolbarIconStyle = {
        display: "block",
        borderColor: "transparent",
        color: "#5454ec",
        cursor: "pointer",
        fontSize: "18px",
        width: "18px",
        height: "18px"
    };
    const toolbarImageIconStyle = {
        display: "block",
        borderColor: "transparent",
        cursor: "pointer",
        width: "18px",
        height: "18px"
    };
    const handleToolbarButtonMouseEnter = (event) => {
        event.currentTarget.style.borderColor = toolbarButtonHoverBorderColor;
    };
    const handleToolbarButtonMouseLeave = (event) => {
        event.currentTarget.style.borderColor = toolbarButtonBorderColor;
    };
    const getAccountId = (accountItem) => {
        return accountItem?.accountId
    }
    const normalizeLookupOptions = (response) => {
        let items = response;
        if (!items || !Array.isArray(items)) {
            return [];
        }
        return items.map((item) => {
            return {
                id: item.systemUserId,
                name: item.firstName + " " + item.lastName,
                email: item.email
            };
        }).filter((item) => item.name);
    };
    const getSalesUserOptionById = (options, selectedId) => {
        const lookupId = normalizeCompareValue(selectedId);
        if (!lookupId) {
            return null;
        }
        return options.find((option) => normalizeCompareValue(option.id) === lookupId) || null;
    };
    const mapSalesRepAndCoordinatorNames = (accountItem, options) => {
        if (!accountItem) {
            return accountItem;
        }
        const salesRepId = accountItem.salesrepid || accountItem.tt_salesrepid || accountItem.tt_SalesRepId || "";
        const salesCoordinatorId = accountItem.salescoordinatorid || accountItem.tt_salescoordinatorid || accountItem.tt_SalesCoordinatorId || "";
        const selectedSalesRep = getSalesUserOptionById(options, salesRepId);
        const selectedSalesCoordinator = getSalesUserOptionById(options, salesCoordinatorId);
        return {
            ...accountItem,
            salesrepid: salesRepId,
            tt_salesrepid: salesRepId,
            tt_SalesRepId: salesRepId,
            salesrepname: selectedSalesRep ? selectedSalesRep.name : accountItem.salesrepname,
            salesrepemailaddress: selectedSalesRep ? selectedSalesRep.email : accountItem.salesrepemailaddress,
            salescoordinatorid: salesCoordinatorId,
            tt_salescoordinatorid: salesCoordinatorId,
            tt_SalesCoordinatorId: salesCoordinatorId,
            salescoordinatorname: selectedSalesCoordinator ? selectedSalesCoordinator.name : accountItem.salescoordinatorname,
            salescoordinatoremailaddress: selectedSalesCoordinator ? selectedSalesCoordinator.email : accountItem.salescoordinatoremailaddress
        };
    };
    const normalizeContactOptions = (response) => {
        const items = response || [];
        if (!Array.isArray(items)) {
            return [];
        }
        return items.map((item) => ({
            id: item.contactid || "",
            name: item.fullname || "",
            email: item.emailaddress1 || ""
        })).filter((item) => item.id || item.name);
    };
    const normalizeCompareValue = (value) => {
        return value ? value.toString().trim().toLowerCase() : "";
    };
    const getSelectedStateOption = (stateValue) => {
        const normalizedStateValue = normalizeCompareValue(stateValue);

        if (!normalizedStateValue) {
            return null;
        }

        return usStateOptions.find((stateOption) => (
            normalizeCompareValue(stateOption.code) === normalizedStateValue
            || normalizeCompareValue(stateOption.name) === normalizedStateValue
            || normalizeCompareValue(stateOption.text) === normalizedStateValue
        )) || null;
    };

    const getStateCodeValue = (stateValue) => {
        if (stateValue === undefined || stateValue === null || stateValue === "") {
            return "";
        }

        const selectedState = getSelectedStateOption(stateValue);
        return selectedState ? selectedState.code : stateValue.toString().trim();
    };

    const getSelectedLookupOption = (options, selectedId, selectedName, selectedEmail) => {
        const lookupId = normalizeCompareValue(selectedId);
        const lookupName = normalizeCompareValue(selectedName);
        const lookupEmail = normalizeCompareValue(selectedEmail);
        return options.find((option) => {
            const optionId = normalizeCompareValue(option.id);
            const optionName = normalizeCompareValue(option.name);
            const optionEmail = normalizeCompareValue(option.email);
            return (lookupId && optionId === lookupId)
                || (lookupName && optionName === lookupName)
                || (lookupEmail && optionEmail === lookupEmail);
        }) || null;
    };
    const getOptionNumberValue = (value) => {
        if (value === undefined || value === null || value === "") {
            return null;
        }

        const numberValue = Number(value);
        return Number.isNaN(numberValue) ? null : numberValue;
    };

    const getSelectedNumberOption = (options, selectedValue) => {
        const selectedNumberValue = getOptionNumberValue(selectedValue);

        if (selectedNumberValue !== null) {
            return options.find((option) => Number(option.value) === selectedNumberValue) || null;
        }

        const selectedText = normalizeCompareValue(selectedValue);

        if (selectedText) {
            return options.find((option) => normalizeCompareValue(option.text) === selectedText) || null;
        }

        return null;
    };

    const getAccountCategoryCodeValue = (accountItem) => {
        if (!accountItem) {
            return defaultAccountCategoryCodeValue;
        }

        const accountCategoryCodeValue = getOptionNumberValue(accountItem.account_category_code);
        return accountCategoryCodeValue !== null ? accountCategoryCodeValue : defaultAccountCategoryCodeValue;
    };

    const getAccountStatusNumberValue = (accountItem) => {
        if (!accountItem) {
            return defaultAccountStatusNumberValue;
        }

        const accountStatusNumberValue = getOptionNumberValue(accountItem.tt_status_number);
        if (accountStatusNumberValue !== null) {
            return accountStatusNumberValue;
        }

        const accountStatusValue = getOptionNumberValue(accountItem.tt_status);
        return accountStatusValue !== null ? accountStatusValue : defaultAccountStatusNumberValue;
    };

    const getAccountCategoryCodeDisplayText = (accountItem) => {
        const selectedOption = getSelectedNumberOption(accountCategoryCodeOptions, getAccountCategoryCodeValue(accountItem));
        return selectedOption ? selectedOption.text : "";
    };

    const getAccountStatusNumberDisplayText = (accountItem) => {
        const selectedOption = getSelectedNumberOption(accountStatusNumberOptions, getAccountStatusNumberValue(accountItem));
        return selectedOption ? selectedOption.text : "";
    };

    const getSelectedAccountCategoryCodeOption = (accountItem) => {
        return getSelectedNumberOption(accountCategoryCodeOptions, getAccountCategoryCodeValue(accountItem));
    };

    const getSelectedAccountStatusNumberOption = (accountItem) => {
        return getSelectedNumberOption(accountStatusNumberOptions, getAccountStatusNumberValue(accountItem));
    };

    const getDefaultAccountCategoryCodeOption = () => {
        return getSelectedNumberOption(accountCategoryCodeOptions, defaultAccountCategoryCodeValue);
    };

    const getDefaultAccountStatusNumberOption = () => {
        return getSelectedNumberOption(accountStatusNumberOptions, defaultAccountStatusNumberValue);
    };

    const getSelectedContactOption = (options, selectedId) => {
        const lookupId = normalizeCompareValue(selectedId);
        return options.find((option) => normalizeCompareValue(option.id) === lookupId) || null;
    };

    const getGpAccountMappedValues = (gpAccount, accountNumber) => {
        if (!gpAccount) {
            return {};
        }

        const resolvedAccountNumber = gpAccount.accountnumber !== undefined && gpAccount.accountnumber !== null && gpAccount.accountnumber !== ""
            ? gpAccount.accountnumber
            : accountNumber;
        const resolvedPostalCode = gpAccount.postal_code || "";
        const resolvedStateCode = getStateCodeValue(gpAccount.address1_stateorprovince);

        return {
            accountId: gpAccount.accountId || "",
            primarycontactid: gpAccount.primarycontactid || "",
            primarycontactname: gpAccount.primarycontactname || "",
            accountnumber: resolvedAccountNumber,
            name: gpAccount.name || "",
            tt_statementname: gpAccount.tt_statementname || "",
            tt_grades: gpAccount.tt_grades || "",
            tt_status_number: getAccountStatusNumberValue(gpAccount),
            tt_status_number_display: getAccountStatusNumberDisplayText(gpAccount),
            account_category_code: getAccountCategoryCodeValue(gpAccount),
            customer_status: getAccountCategoryCodeValue(gpAccount),
            account_category_code_display: getAccountCategoryCodeDisplayText(gpAccount),
            customertypecode: gpAccount.customertypecode || "",
            tt_SalesCoordinatorId: gpAccount.tt_SalesCoordinatorId || "",
            tt_salescoordinatorid: gpAccount.tt_SalesCoordinatorId || "",
            address1_line1: gpAccount.address1_line1 || "",
            address1_line2: gpAccount.address1_line2 || "",
            address1_stateorprovince: resolvedStateCode,
            tt_stateprovinceid: resolvedStateCode,
            postal_code: resolvedPostalCode,
            address1_postalcode: resolvedPostalCode,
            address1_name: gpAccount.address1_name || "",
            address1_county: gpAccount.address1_county || "",
            address1_city: gpAccount.address1_city || "",
            address1_telephone1: gpAccount.address1_telephone1 || "",
            salescoordinatoremailaddress: gpAccount.salescoordinatoremailaddress || "",
            salescoordinatorname: gpAccount.salescoordinatorname || "",
            salesrepemailaddress: gpAccount.salesrepemailaddress || "",
            salesrepname: gpAccount.salesrepname || "",
            schoolemailaddress: gpAccount.schoolemailaddress || ""
        };
    };

    const requiredValidator = (value, message) => {
        return value && value.toString().trim() ? "" : message;
    };

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const accountNumberValidator = () => {
        const accountNumber = newAccount.accountnumber ? newAccount.accountnumber.toString().trim() : "";
        if (!accountNumber) {
            return "Account number is required.";
        }
        if (!/^\d{4,5}$/.test(accountNumber)) {
            return "Account number should be four or five digits long.";
        }
        return "";
    };
    const validateAccountForm = () => {
        const errors = {
            name: requiredValidator(newAccount.name, "Account Name is required."),
            accountnumber: accountNumberValidator(),
            primarycontactid: isEditMode
                ? requiredValidator(
                    newAccount.primarycontactid,
                    "Primary Contact is required."
                )
                : "",
            tt_salesrepid: requiredValidator(
                newAccount.tt_salesrepid || newAccount.salesrepid || newAccount.tt_SalesRepId || newAccount.salesrepname,
                "Sales Rep is required."
            ),
            tt_salescoordinatorid: requiredValidator(
                newAccount.tt_salescoordinatorid || newAccount.tt_SalesCoordinatorId || newAccount.salescoordinatorname,
                "Sales Coordinator is required."
            )
        };
        setValidationErrors(errors);
        return !Object.values(errors).some((errorMessage) => errorMessage);
    };
    const renderRequiredAsterisk = () => (
        <span style={{ color: "#d51923" }}>*</span>
    );
    const renderValidationError = (fieldName) => {
        if (!validationErrors[fieldName]) {
            return null;
        }
        return (
            <div style={{ color: "#d51923", fontSize: "12px", fontWeight: "bold", marginTop: "4px" }}>
                {validationErrors[fieldName]}
            </div>
        );
    };
    const buildAccountInModelInput = () => {
        const accountName = newAccount.name ? newAccount.name.trim() : "";
        const accountNumber = newAccount.accountnumber ? newAccount.accountnumber.toString().trim() : "";
        const accountStateCode = getStateCodeValue(newAccount.address1_stateorprovince);
        const accountPostalCode = newAccount.address1_postalcode || "";
        const selectedAccountCategoryCode = getAccountCategoryCodeValue(newAccount);
        const selectedAccountStatusNumber = getAccountStatusNumberValue(newAccount);
        const primaryContactTelephone = (primaryContactDraft.telephoneNumber || primaryContactDraft.telephone1 || "").toString().trim();
        const primaryContactStateCode = getStateCodeValue(primaryContactDraft.address1_stateorprovince || primaryContactDraft.tt_stateprovinceid);

        if (!isEditMode) {
            return {
                accountnumber: accountNumber,
                name: accountName,
                tt_status_number: selectedAccountStatusNumber,
                account_category_code: selectedAccountCategoryCode,
                customer_status: selectedAccountCategoryCode,
                tt_salesrepid: newAccount.tt_salesrepid || newAccount.tt_SalesRepId || newAccount.salesrepid || null,
                tt_salescoordinatorid: newAccount.tt_salescoordinatorid || newAccount.tt_SalesCoordinatorId || null,
                acc_add_line1: newAccount.address1_line1 || "",
                acc_add_line2: newAccount.address1_line2 || "",
                acc_add_county: newAccount.address1_county || "",
                acc_telephone1: newAccount.address1_telephone1 || "",
                acc_add_city: newAccount.address1_city || "",
                acc_tt_stateprovinceid: accountStateCode,
                acc_add_postalcode: accountPostalCode,
                tt_grades: newAccount.tt_grades || "",
                firstName: primaryContactDraft.firstName || "",
                lastName: primaryContactDraft.lastName || "",
                telephone1: primaryContactTelephone,
                emailaddress1: primaryContactDraft.emailaddress1 || "",
                address1_line1: primaryContactDraft.address1_line1 || "",
                address1_line2: primaryContactDraft.address1_line2 || "",
                address1_county: primaryContactDraft.address1_county || "",
                address1_city: primaryContactDraft.address1_city || "",
                tt_stateprovinceid: primaryContactStateCode,
                address1_postalcode: primaryContactDraft.address1_postalcode || ""
            };
        }

        return {
            Id: getAccountId(newAccount) || getAccountId(editingAccountItem) || "00000000-0000-0000-0000-000000000000",
            accountnumber: accountNumber ? [accountNumber] : [],
            columnnames: [
                "name",
                "accountnumber",
                "parentaccountid",
                "primarycontactid",
                "account_category_code",
                "emailaddress1",
                "tt_salesrepid",
                "tt_salescoordinatorid",
                "tt_grades",
                "tt_status_number",
                "address1_line1",
                "address1_line2",
                "address1_line3",
                "address1_county",
                "address1_telephone1",
                "address1_city",
                "address1_stateorprovince",
                "address1_postalcode",
                "tt_StatementName",
                "tt_stateprovinceid",
                "tt_programschedulecomplete",
                "tt_GPUpdateFlag",
                "tt_taxexemptinfo",
                "tt_taxexcemptexpirationdate"
            ],
            name: accountName,
            parentaccountid: newAccount.parentaccountid || null,
            primarycontactid: newAccount.primarycontactid || null,
            account_category_code: selectedAccountCategoryCode,
            emailaddress1: newAccount.emailaddress1 || newAccount.schoolemailaddress || "",
            tt_salesrepid: newAccount.salesrepid || newAccount.tt_salesrepid || newAccount.tt_SalesRepId || null,
            tt_salescoordinatorid: newAccount.salescoordinatorid || newAccount.tt_salescoordinatorid || newAccount.tt_SalesCoordinatorId || null,
            tt_grades: newAccount.tt_grades || "",
            tt_status_number: selectedAccountStatusNumber,
            address1_line1: newAccount.address1_line1 || "",
            address1_line2: newAccount.address1_line2 || "",
            address1_line3: newAccount.address1_line3 || "",
            address1_county: newAccount.address1_county || "",
            address1_telephone1: newAccount.address1_telephone1 || "",
            address1_city: newAccount.address1_city || "",
            address1_stateorprovince: accountStateCode,
            address1_postalcode: accountPostalCode,
            tt_StatementName: newAccount.tt_StatementName || newAccount.tt_statementname || "",
            tt_stateprovinceid: accountStateCode,
            tt_programschedulecomplete: !!newAccount.tt_programschedulecomplete,
            tt_GPUpdateFlag: !!newAccount.tt_GPUpdateFlag,
            tt_taxexemptinfo: newAccount.tt_taxexemptinfo || "",
            tt_taxexcemptexpirationdate: newAccount.tt_taxexcemptexpirationdate || ""
        };
    };

    React.useEffect(() => {
        refreshAccounts();
        loadSalesRepAndCoordinators();
    }, []);
    React.useEffect(() => {
        if (salesCoordAndRepOptions.length <= 0) {
            return;
        }
        setData((previousData) => previousData.map((accountItem) => mapSalesRepAndCoordinatorNames(accountItem, salesCoordAndRepOptions)));
        setNewAccount((previousAccount) => mapSalesRepAndCoordinatorNames(previousAccount, salesCoordAndRepOptions));
    }, [salesCoordAndRepOptions]);
    const refreshAccounts = (msg) => {
        props.onLoaderRaise(true, "Loading account list ...", { marginTop: "145px" });
        APIConnector.Get(CommonVariables.urls.GetAllAccounts).then(function (response) {
            props.onLoaderRaise(false);
            if (!CommonVariables.isError(response))
                return;

            response = (response || []).map((item) => {
                const stateCode = getStateCodeValue(item.address1_stateorprovince);
                return {
                    ...item,
                    tt_status_number: getOptionNumberValue(item.tt_status),
                    tt_status_number_display: getAccountStatusNumberDisplayText(item),
                    account_category_code: getAccountCategoryCodeValue(item),
                    customer_status: getAccountCategoryCodeValue(item),
                    account_category_code_display: getAccountCategoryCodeDisplayText(item),
                    address1_stateorprovince: stateCode,
                    tt_stateprovinceid: stateCode,
                    address1_postalcode: item.postal_code || "",
                    postal_code: item.postal_code || ""
                };
            });

            if (salesCoordAndRepOptions.length > 0) {
                response = response.map((item) => mapSalesRepAndCoordinatorNames(item, salesCoordAndRepOptions));
            }

            setData(response);
            if (msg) {
                Notifications.ShowSuccessMessage(msg);
            }
        });
    };
    const refreshAccountContacts = (accountItem) => {
        const accountId = getAccountId(accountItem);
        if (!accountId) {
            setAccountContacts([]);
            setPrimaryContactOptions([]);
            return;
        }

        const crmInput = {
            parentCustomerId: accountId
        };

        props.onLoaderRaise(true, "Loading contact list ...", { marginTop: "145px" });
        APIConnector.Post(CommonVariables.urls.GetContactsByAccountId, crmInput).then(function (response) {
            props.onLoaderRaise(false);

            if (!CommonVariables.isError(response)) {
                return;
            }

            const accountContactList = mapContactResponse(response || []);
            setAccountContacts(accountContactList);
            setPrimaryContactOptions(normalizeContactOptions(accountContactList));
        });
    };
    const loadPrimaryContacts = () => {
        props.onLoaderRaise(true, "Loading contacts ...", { marginTop: "145px" });
        APIConnector.Get(CommonVariables.urls.GetAllContacts).then(function (response) {
            props.onLoaderRaise(false);
            if (!CommonVariables.isError(response))
                return;
            setPrimaryContactOptions(normalizeContactOptions(response));
        });
    };
    const loadSalesRepAndCoordinators = () => {
        props.onLoaderRaise(true, "Loading sales users ...", { marginTop: "145px" });
        APIConnector.Post(CommonVariables.urls.GetAllSalesCoordAndRep, {userId: CommonVariables.getlocalstorageData().userId}).then(function (response) {
            props.onLoaderRaise(false);
            if (!CommonVariables.isError(response))
                return;
            const systemUserOptions = normalizeLookupOptions(response);
            setsalesCoordAndRepOptions(systemUserOptions);
            setData((previousData) => previousData.map((accountItem) => mapSalesRepAndCoordinatorNames(accountItem, systemUserOptions)));
            setNewAccount((previousAccount) => mapSalesRepAndCoordinatorNames(previousAccount, systemUserOptions));
        });
    };
    //#endregion
    //#region "     Print Functionality     "
    let gridPDFExport;
    const exportPDF = () => {
        if (gridPDFExport) {
            gridPDFExport.save(data);
        }
    };
    //#endregion
    //#region "     Export to Excel functionality    "
    let _export;
    const exportExcel = () => {
        _export.save(data);
    };
    //#endregion
    //#region "     Add Account Dialog Events        "
    const openAddAccountDialog = () => {
        setIsEditMode(false);
        setEditingAccountItem(null);
        setAccountContacts([]);
        setPrimaryContactOptions([]);
        setValidationErrors({});
        setNewAccount({ ...emptyAccount });
        setIsGpAccountLoaded(false);
        setShowCreatePrimaryContactSection(false);
        setPrimaryContactDraft(getEmptyPrimaryContactDraft());
        setShowAddAccountDialog(true);
        loadSalesRepAndCoordinators();
    };
    const openEditAccountDialog = (accountItem) => {
        const stateCode = getStateCodeValue(accountItem.address1_stateorprovince);

        setIsEditMode(true);
        setEditingAccountItem(accountItem);
        setValidationErrors({});
        setIsGpAccountLoaded(true);
        setShowCreatePrimaryContactSection(false);
        setPrimaryContactDraft(getEmptyPrimaryContactDraft());
        setNewAccount({
            ...emptyAccount,
            ...accountItem,
            tt_status_number: getOptionNumberValue(accountItem.tt_status),
            tt_status_number_display: getAccountStatusNumberDisplayText(accountItem),
            customer_status: getAccountCategoryCodeValue(accountItem),
            account_category_code: getAccountCategoryCodeValue(accountItem),
            account_category_code_display: getAccountCategoryCodeDisplayText(accountItem),
            salesrepid: accountItem.salesrepid || accountItem.tt_salesrepid || accountItem.tt_SalesRepId || "",
            tt_salesrepid: accountItem.salesrepid || accountItem.tt_salesrepid || accountItem.tt_SalesRepId || "",
            tt_SalesRepId: accountItem.salesrepid || accountItem.tt_salesrepid || accountItem.tt_SalesRepId || "",
            salescoordinatorid: accountItem.salescoordinatorid || accountItem.tt_salescoordinatorid || accountItem.tt_SalesCoordinatorId || "",
            tt_salescoordinatorid: accountItem.salescoordinatorid || accountItem.tt_salescoordinatorid || accountItem.tt_SalesCoordinatorId || "",
            tt_SalesCoordinatorId: accountItem.salescoordinatorid || accountItem.tt_salescoordinatorid || accountItem.tt_SalesCoordinatorId || "",
            address1_stateorprovince: stateCode,
            tt_stateprovinceid: stateCode,
            address1_postalcode: accountItem.postal_code || "",
            postal_code: accountItem.postal_code || ""
        });
        setShowAddAccountDialog(true);
        loadSalesRepAndCoordinators();
        setPrimaryContactOptions([]);
        refreshAccountContacts(accountItem);
    };
    const closeAddAccountDialog = () => {
        setShowAddAccountDialog(false);
        setIsEditMode(false);
        setEditingAccountItem(null);
        setAccountContacts([]);
        setPrimaryContactOptions([]);
        setValidationErrors({});
        setNewAccount({ ...emptyAccount });
        setIsGpAccountLoaded(false);
        setShowCreatePrimaryContactSection(false);
        setPrimaryContactDraft(getEmptyPrimaryContactDraft());
    };
    const handleNewAccountChange = (fieldName, value) => {
        setNewAccount((previousAccount) => ({
            ...previousAccount,
            [fieldName]: value
        }));
        setValidationErrors((previousErrors) => ({
            ...previousErrors,
            [fieldName]: ""
        }));
    };
    const isAccountCreateDetailsDisabled = () => {
        return !isEditMode && !isGpAccountLoaded;
    };

    const isGpLockedAccountField = () => {
        return !isEditMode && isGpAccountLoaded;
    };

    const responsiveTwoColumnSectionStyle = {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
        gap: "16px",
        gridColumn: "1 / 3"
    };

    const sectionBoxStyle = {
        border: "1px solid #d9d9d9",
        borderRadius: "6px",
        padding: "12px",
        backgroundColor: "#fafafa"
    };

    const sectionTitleStyle = {
        margin: "0 0 10px 0",
        fontSize: "15px",
        fontWeight: "bold"
    };

    const sectionGridStyle = {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
        gap: "12px 14px"
    };

    const handlePrimaryContactDraftChange = (fieldName, value) => {
        setPrimaryContactDraft((previousContact) => {
            const nextContact = {
                ...previousContact,
                [fieldName]: value
            };

            if (fieldName === "telephoneNumber") {
                nextContact.telephone1 = buildTelephoneValue(nextContact.telephoneNumber || "");
                nextContact.mobilephone = nextContact.telephone1;
            }

            return nextContact;
        });

        setValidationErrors((previousErrors) => ({
            ...previousErrors,
            [`primaryContact_${fieldName}`]: "",
            primarycontactid: ""
        }));
    };

    const validatePrimaryContactDraft = () => {
        const telephone = buildTelephoneValue(primaryContactDraft.telephoneNumber || primaryContactDraft.telephone1 || "");

        const errors = {
            primaryContact_firstName: requiredValidator(primaryContactDraft.firstName, "First Name is required."),
            primaryContact_lastName: requiredValidator(primaryContactDraft.lastName, "Last Name is required."),
            primaryContact_emailaddress1: !primaryContactDraft.emailaddress1
                ? "Email is required."
                : !emailRegex.test(primaryContactDraft.emailaddress1.toString().trim())
                    ? "Invalid email address."
                    : "",
            primaryContact_telephoneNumber: telephone
                ? telephone.length > 18
                    ? "Telephone cannot exceed 18 characters."
                    : !phoneRegex.test(telephone)
                        ? "Invalid phone number."
                        : ""
                : ""
        };

        setValidationErrors((previousErrors) => ({
            ...previousErrors,
            ...errors
        }));

        return !Object.values(errors).some((errorMessage) => errorMessage);
    };

    const handleFetchAccountFromGP = () => {
        const accountNumber = newAccount.accountnumber ? newAccount.accountnumber.toString().trim() : "";

        if (!accountNumber) {
            setValidationErrors((previousErrors) => ({
                ...previousErrors,
                accountnumber: "Account number is required before fetching from GP."
            }));
            return;
        }

        props.onLoaderRaise(true, "Fetching account from GP ...", { marginTop: "145px" });
        APIConnector.Get(CommonVariables.urls.GetAccountsFromGP, {
            account_number: accountNumber
        }).then(function (response) {
            props.onLoaderRaise(false);

            if (!CommonVariables.isError(response)) {
                return;
            }

            const gpAccount = response;

            if (!gpAccount || !gpAccount.accountnumber) {
                Notifications.ShowWarningMessage("No Account Found for the Given Account Number");
                return;
            }

            const mappedGpAccount = getGpAccountMappedValues(gpAccount, accountNumber);

            setNewAccount((previousAccount) => ({
                ...previousAccount,
                ...mappedGpAccount,
                accountnumber: mappedGpAccount.accountnumber || accountNumber,
                gpAccountLoaded: true
            }));

            setIsGpAccountLoaded(true);
            setValidationErrors((previousErrors) => ({
                ...previousErrors,
                accountnumber: "",
                name: "",
                status: ""
            }));
            Notifications.ShowSuccessMessage("Account details fetched from GP.");
        });
    };

    const handleAccountNumberKeyDown = (event) => {
        if (event.key === "Enter" && !isEditMode) {
            event.preventDefault();
            handleFetchAccountFromGP();
        }
    };

    const handleShowCreatePrimaryContactSection = () => {
        setShowCreatePrimaryContactSection(true);
        setValidationErrors((previousErrors) => ({
            ...previousErrors,
            primarycontactid: ""
        }));
    };

    const saveNewAccount = () => {
        if (!isEditMode && !isGpAccountLoaded) {
            setValidationErrors((previousErrors) => ({
                ...previousErrors,
                accountnumber: "Fetch account details from GP before adding the account."
            }));
            Notifications.ShowWarningMessage("Fetch account details from GP before adding the account.");
            return;
        }

        if (!validateAccountForm()) {
            return;
        }

        if (!isEditMode && showCreatePrimaryContactSection && !validatePrimaryContactDraft()) {
            return;
        }

        const accountInputModel = buildAccountInModelInput();

        const apiUrl = isEditMode
            ? CommonVariables.urls.UpdateAccount
            : CommonVariables.urls.CreateAccount;

        props.onLoaderRaise(true, isEditMode ? "Updating account ..." : "Creating account ...", { marginTop: "145px" });
        APIConnector.Post(apiUrl, accountInputModel).then(async function (response) {
            if (!CommonVariables.isError(response)) {
                props.onLoaderRaise(false);
                return;
            }

            if (isEditMode) {
                props.onLoaderRaise(false);
                closeAddAccountDialog();
                refreshAccounts("Account updated successfully");
                return;
            }

            const createdAccountId = response.Id;

            if (!createdAccountId) {
                props.onLoaderRaise(false);
                closeAddAccountDialog();
                refreshAccounts("Account added successfully");
                return;
            }

            props.onLoaderRaise(false);

            const createdPrimaryContactName = showCreatePrimaryContactSection && (primaryContactDraft.firstName || primaryContactDraft.lastName)
                ? `${primaryContactDraft.firstName || ""} ${primaryContactDraft.lastName || ""}`.trim()
                : newAccount.primarycontactname || "";
            const createdPrimaryContactEmail = showCreatePrimaryContactSection
                ? primaryContactDraft.emailaddress1 || ""
                : newAccount.schoolemailaddress || newAccount.emailaddress1 || "";
            const selectedAccountCategoryCode = getAccountCategoryCodeValue(newAccount);
            const selectedAccountStatusNumber = getAccountStatusNumberValue(newAccount);

            const createdAccountItem = {
                ...newAccount,
                accountId: createdAccountId,
                accountid: createdAccountId,
                id: createdAccountId,
                Id: createdAccountId,
                primarycontactid: newAccount.primarycontactid || "",
                account_category_code: selectedAccountCategoryCode,
                customer_status: selectedAccountCategoryCode,
                account_category_code_display: getAccountCategoryCodeDisplayText({ account_category_code: selectedAccountCategoryCode }),
                tt_status_number: selectedAccountStatusNumber,
                tt_status_number_display: getAccountStatusNumberDisplayText({ tt_status_number: selectedAccountStatusNumber }),
                primarycontactname: createdPrimaryContactName,
                schoolemailaddress: createdPrimaryContactEmail || newAccount.schoolemailaddress || "",
                emailaddress1: createdPrimaryContactEmail || newAccount.emailaddress1 || ""
            };

            setIsEditMode(true);
            setEditingAccountItem(createdAccountItem);
            setNewAccount(createdAccountItem);
            setAccountContacts([]);
            setShowCreatePrimaryContactSection(false);
            setPrimaryContactDraft(getEmptyPrimaryContactDraft());
            refreshAccounts("Account added successfully");
            refreshAccountContacts(createdAccountItem);
        });
    };

    const getCurrentEditingAccountId = () => {
        return getAccountId(editingAccountItem) || getAccountId(newAccount) || "";
    };
    const getCurrentEditingAccountName = () => {
        return newAccount.name || editingAccountItem?.name || "";
    };
    const getProtectedPrimaryContactIds = () => {
        return [
            newAccount.primarycontactid,
            editingAccountItem?.primarycontactid
        ]
            .map((contactId) => normalizeCompareValue(contactId))
            .filter((contactId, index, contactIds) => contactId && contactIds.indexOf(contactId) === index);
    };
    const isPrimaryContactGridRow = (contactItem) => {
        const contactId = normalizeCompareValue(getContactId(contactItem));
        return !!contactId && getProtectedPrimaryContactIds().includes(contactId);
    };
    const openAddAccountContactDialog = () => {
        const accountId = getCurrentEditingAccountId();
        setIsContactEditMode(false);
        setEditingContactItem(null);
        setContactValidationErrors({});
        setNewContact({
            ...emptyContact,
            parentCustomerId: accountId
        });
        setShowContactDialog(true);
    };
    const openEditAccountContactDialog = (contactItem) => {
        const mappedContact = mapContactResponse([contactItem])[0];
        setIsContactEditMode(true);
        setEditingContactItem(contactItem);
        setContactValidationErrors({});
        setNewContact({
            ...emptyContact,
            ...mappedContact,
            parentCustomerId: getCurrentEditingAccountId(),
            address_type: mappedContact.address_type || ""
        });
        setShowContactDialog(true);
    };
    const closeAccountContactDialog = () => {
        setShowContactDialog(false);
        setIsContactEditMode(false);
        setEditingContactItem(null);
        setContactValidationErrors({});
        setNewContact({ ...emptyContact });
    };
    const handleAccountContactSaved = (response, wasEditMode) => {
        closeAccountContactDialog();
        refreshAccountContacts(editingAccountItem || newAccount);
        Notifications.ShowSuccessMessage(wasEditMode ? "Contact updated successfully" : "Contact added successfully");
    };
    const openDeleteContactDialog = (contactItem) => {
        if (isPrimaryContactGridRow(contactItem)) {
            Notifications.ShowWarningMessage("Primary Contact cannot be removed from this account. Change the Primary Contact field instead.");
            return;
        }
        setDeleteContactItem(contactItem);
        setDeleteContactDialogOpen(true);
    };
    const closeDeleteContactDialog = () => {
        setDeleteContactItem(null);
        setDeleteContactDialogOpen(false);
    };
    const confirmDeleteAccountContact = () => {
        const contactId = getContactId(deleteContactItem);
        if (!contactId) {
            Notifications.ShowErrorMessage("Contact Id was not found.");
            return;
        }
        if (isPrimaryContactGridRow(deleteContactItem)) {
            Notifications.ShowWarningMessage("Primary Contact cannot be removed from this account. Change the Primary Contact field instead.");
            closeDeleteContactDialog();
            return;
        }
        props.onLoaderRaise(true, "Removing contact from account ...", { marginTop: "145px" });
        unassignContactFromAccount(contactId).then(function (response) {
            props.onLoaderRaise(false);
            if (!CommonVariables.isError(response))
                return;
            if (response === true || response?.isSuccess || response?.IsSuccess) {
                closeDeleteContactDialog();
                refreshAccountContacts(editingAccountItem || newAccount);
                Notifications.ShowSuccessMessage("Contact removed from account successfully.");
            }
            else {
                Notifications.ShowErrorMessage("Something went wrong. Please try again.");
            }
        });
    };
    //#endregion
    //#region "     Modal Dialog Events        "
    const ContactEditCommandCell = (props) => {
        return (
            <td style={{ textAlign: "center" }}>
                <span title="Edit">
                    <EditIcon
                        onClick={() => openEditAccountContactDialog(props.dataItem)}
                        title="Edit"
                        style={{ display: "inline-block", borderColor: "transparent", color: "#5454ec", cursor: "pointer" }}
                    />
                </span>
            </td>
        );
    };
    const ContactDeleteCommandCell = (props) => {
        const isPrimaryContact = isPrimaryContactGridRow(props.dataItem);
        const deleteTitle = isPrimaryContact
            ? "Primary Contact cannot be removed. Change the Primary Contact field instead."
            : "Remove Contact";
        return (
            <td style={{ textAlign: "center" }}>
                <span title={deleteTitle}>
                    <DeleteIcon
                        onClick={isPrimaryContact ? undefined : () => openDeleteContactDialog(props.dataItem)}
                        title={deleteTitle}
                        style={{
                            display: "inline-block",
                            borderColor: "transparent",
                            color: isPrimaryContact ? "#999999" : "#d51923",
                            cursor: isPrimaryContact ? "not-allowed" : "pointer",
                            opacity: isPrimaryContact ? 0.45 : 1
                        }}
                    />
                </span>
            </td>
        );
    };
    //#region "     Grid        "
    //#region "     Custom Cells    "
    const MyEditCommandCell = (props) => (
        <EditCommandCell {...props} enterEdit={enterEdit} />
    );
    const EditCommandCell = (props) => {
        return (
            <td className="flex justify-evenly">
                <span title="Edit">
                    <EditIcon onClick={() => props.enterEdit(props.dataItem)} title="Edit" style={{ "display": "inline-block", "borderColor": "transparent", "color": "#5454ec", "cursor": "pointer" }} />
                </span>
            </td>
        );
    };
    const enterEdit = (item) => {
        openEditAccountDialog(item);
    };
    //#endregion
    const gridData = orderBy(filterBy(data, filter), sort);
    const grid = (
        <Grid className="rounded-2xl border-b-4" style={{ height: (window.innerHeight - 317) + "px" }}
            data={gridData}
            sortable={{ allowUnsort: true, mode: "single" }}
            sort={sort}
            onSortChange={(e) => setSort(e.sort)}
            pageable={true}
            take={1000}
            total={gridData.length}
            resizable={true}
            selectable={{
                enabled: true,
                drag: false,
                cell: false,
                mode: "single"
            }}>
            <GridNoRecords>
                No Accounts available
            </GridNoRecords>
            {renderAccountColumns()}
            <Column cell={MyEditCommandCell} width="60" title="Edit" sortable={false} />
        </Grid>
    );
    //#endregion
    return (
        <div className="PageStyle">
            <h2 className="inline-block pt-1 primary-heading">Accounts</h2>
            <div className="row" style={{ "marginRight": "auto" }}>
                <div className="col-sm-6">
                    <Filter
                        value={filter}
                        onChange={(e) => setFilter(e.filter)}
                        fields={accountGridFields}
                    />
                </div>
                <div className="col-sm-6" style={{ marginTop: "auto", marginRight: "auto",paddingRight:0, textAlign: "end" }}>
                    <span
                        title="Add Account"
                        onClick={openAddAccountDialog}
                        onMouseEnter={handleToolbarButtonMouseEnter}
                        onMouseLeave={handleToolbarButtonMouseLeave}
                        style={toolbarButtonStyle}
                    >
                        <span>Add Account</span>
                        <AccountCircle style={toolbarIconStyle} />
                    </span>
                    <span
                        title="Print"
                        onClick={exportPDF}
                        onMouseEnter={handleToolbarButtonMouseEnter}
                        onMouseLeave={handleToolbarButtonMouseLeave}
                        style={toolbarButtonStyle}
                    >
                        <span>Print</span>
                        <PrintIcon style={toolbarIconStyle} />
                    </span>
                    <span
                        title="Excel"
                        onClick={exportExcel}
                        onMouseEnter={handleToolbarButtonMouseEnter}
                        onMouseLeave={handleToolbarButtonMouseLeave}
                        style={toolbarButtonStyle}
                    >
                        <span>Export to Excel</span>
                        <TableChart style={toolbarIconStyle} />
                    </span>
                    <span
                        title="Refresh grid"
                        onClick={refreshAccounts}
                        onMouseEnter={handleToolbarButtonMouseEnter}
                        onMouseLeave={handleToolbarButtonMouseLeave}
                        style={toolbarButtonStyle}
                    >
                        <span>Refresh</span>
                        <RefreshIcon style={toolbarIconStyle} />
                    </span>
                </div>
            </div>
            {grid}
            {showAddAccountDialog && (
                <Dialog title={isEditMode ? "Edit Account" : "Add Account"} onClose={closeAddAccountDialog} width={760}>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "14px 16px", padding: "8px 4px" }}>
                        <div>
                            <label style={{ display: "block", marginBottom: "4px" }}>Account # {renderRequiredAsterisk()}</label>
                            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                <Input
                                    required={true}
                                    disabled={isEditMode || isGpLockedAccountField()}
                                    value={newAccount.accountnumber}
                                    onChange={(e) => {
                                        handleNewAccountChange("accountnumber", e.value);
                                        if (!isEditMode) {
                                            setIsGpAccountLoaded(false);
                                        }
                                    }}
                                    onKeyDown={handleAccountNumberKeyDown}
                                />
                                {!isEditMode && (
                                    <Button
                                        disabled={isGpLockedAccountField()}
                                        onClick={handleFetchAccountFromGP}
                                    >
                                        Search
                                    </Button>
                                )}
                            </div>
                            {renderValidationError("accountnumber")}
                        </div>

                        <div>
                            <label style={{ display: "block", marginBottom: "4px" }}>Account Name {renderRequiredAsterisk()}</label>
                            <Input
                                required={true}
                                disabled={isAccountCreateDetailsDisabled() || isGpLockedAccountField()}
                                value={newAccount.name}
                                onChange={(e) => handleNewAccountChange("name", e.value)}
                            />
                            {renderValidationError("name")}
                        </div>

                        <div>
                            <label style={{ display: "block", marginBottom: "4px" }}>Customer Status</label>
                            <DropDownList
                                data={accountCategoryCodeOptions}
                                textField="text"
                                dataItemKey="value"
                                disabled={isAccountCreateDetailsDisabled()}
                                value={getSelectedAccountCategoryCodeOption(newAccount)}
                                defaultItem={{ text: "Select Customer Status", value: null }}
                                onChange={(e) => {
                                    handleNewAccountChange("customer_status", e.value?.value ?? null);
                                    handleNewAccountChange("account_category_code", e.value?.value ?? null);
                                }}
                            />
                        </div>

                        <div>
                            <label style={{ display: "block", marginBottom: "4px" }}>Status</label>
                            <DropDownList
                                data={accountStatusNumberOptions}
                                textField="text"
                                dataItemKey="value"
                                disabled={isAccountCreateDetailsDisabled()}
                                value={getSelectedAccountStatusNumberOption(newAccount)}
                                defaultItem={{ text: "Select Status", value: null }}
                                onChange={(e) => {
                                    handleNewAccountChange("tt_status_number", e.value?.value ?? null);
                                }}
                            />
                        </div>

                        <div>
                            <label style={{ display: "block", marginBottom: "4px" }}>Sales Rep {renderRequiredAsterisk()}</label>
                            <DropDownList
                                data={salesCoordAndRepOptions}
                                textField="name"
                                dataItemKey="id"
                                disabled={isAccountCreateDetailsDisabled()}
                                value={getSelectedLookupOption(
                                    salesCoordAndRepOptions,
                                    newAccount.tt_salesrepid || newAccount.salesrepid || newAccount.tt_SalesRepId,
                                    newAccount.salesrepname,
                                    newAccount.salesrepemailaddress
                                )}
                                defaultItem={{ id: "", name: "Select Sales Rep", email: "" }}
                                onChange={(e) => {
                                    handleNewAccountChange("salesrepid", e.value?.id || "");
                                    handleNewAccountChange("tt_salesrepid", e.value?.id || "");
                                    handleNewAccountChange("tt_SalesRepId", e.value?.id || "");
                                    handleNewAccountChange("salesrepname", e.value?.name || "");
                                    handleNewAccountChange("salesrepemailaddress", e.value?.email || "");
                                }}
                            />
                            {renderValidationError("tt_salesrepid")}
                        </div>

                        <div>
                            <label style={{ display: "block", marginBottom: "4px" }}>Sales Coordinator {renderRequiredAsterisk()}</label>
                            <DropDownList
                                data={salesCoordAndRepOptions}
                                textField="name"
                                dataItemKey="id"
                                disabled={isAccountCreateDetailsDisabled()}
                                value={getSelectedLookupOption(
                                    salesCoordAndRepOptions,
                                    newAccount.tt_salescoordinatorid || newAccount.tt_SalesCoordinatorId,
                                    newAccount.salescoordinatorname,
                                    newAccount.salescoordinatoremailaddress
                                )}
                                defaultItem={{ id: "", name: "Select Sales Coordinator", email: "" }}
                                onChange={(e) => {
                                    handleNewAccountChange("salescoordinatorid", e.value?.id || "");
                                    handleNewAccountChange("tt_salescoordinatorid", e.value?.id || "");
                                    handleNewAccountChange("tt_SalesCoordinatorId", e.value?.id || "");
                                    handleNewAccountChange("salescoordinatorname", e.value?.name || "");
                                    handleNewAccountChange("salescoordinatoremailaddress", e.value?.email || "");
                                }}
                            />
                            {renderValidationError("tt_salescoordinatorid")}
                        </div>

                        <div>
                            <label style={{ display: "block", marginBottom: "4px" }}>Grades</label>
                            <Input
                                disabled={isAccountCreateDetailsDisabled()}
                                value={newAccount.tt_grades}
                                onChange={(e) => handleNewAccountChange("tt_grades", e.value)}
                            />
                        </div>

                        <div style={responsiveTwoColumnSectionStyle}>
                            <div style={sectionBoxStyle}>
                                <h4 style={sectionTitleStyle}>Address</h4>
                                <div style={sectionGridStyle}>
                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px" }}>Street 1</label>
                                        <Input
                                            disabled={true}
                                            value={newAccount.address1_line1}
                                            onChange={(e) => handleNewAccountChange("address1_line1", e.value)}
                                        />
                                    </div>

                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px" }}>Street 2</label>
                                        <Input
                                            disabled={true}
                                            value={newAccount.address1_line2}
                                            onChange={(e) => handleNewAccountChange("address1_line2", e.value)}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px" }}>City</label>
                                        <Input
                                            disabled={true}
                                            value={newAccount.address1_city}
                                            onChange={(e) => handleNewAccountChange("address1_city", e.value)}
                                        />
                                    </div>

                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px" }}>State/Province</label>
                                        <DropDownList
                                            data={usStateOptions}
                                            textField="text"
                                            dataItemKey="code"
                                            disabled={true}
                                            value={getSelectedStateOption(newAccount.tt_stateprovinceid || newAccount.address1_stateorprovince)}
                                            defaultItem={{ code: "", name: "", text: "Select State/Province" }}
                                            onChange={(e) => {
                                                const selectedStateCode = e.value?.code || "";
                                                handleNewAccountChange("tt_stateprovinceid", selectedStateCode);
                                                handleNewAccountChange("address1_stateorprovince", selectedStateCode);
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px" }}>Postal Code</label>
                                        <Input
                                            disabled={true}
                                            value={newAccount.postal_code}
                                            onChange={(e) => handleNewAccountChange("postal_code", e.value)}
                                        />
                                    </div>

                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px" }}>County</label>
                                        <Input
                                            disabled={true}
                                            value={newAccount.address1_county}
                                            onChange={(e) => handleNewAccountChange("address1_county", e.value)}
                                        />
                                    </div>

                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px" }}>Address Phone</label>
                                        <Input
                                            disabled={true}
                                            value={newAccount.address1_telephone1}
                                            onChange={(e) => handleNewAccountChange("address1_telephone1", e.value)}
                                        />
                                    </div>
                                </div>
                            </div>

                            {!isEditMode && (
                                <div style={sectionBoxStyle}>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                            marginBottom: showCreatePrimaryContactSection ? "10px" : "0"
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            id="createPrimaryContact"
                                            checked={showCreatePrimaryContactSection}
                                            disabled={isAccountCreateDetailsDisabled()}
                                            onChange={(e) => {
                                                const shouldCreatePrimaryContact = e.target.checked;
                                                setShowCreatePrimaryContactSection(shouldCreatePrimaryContact);

                                                if (!shouldCreatePrimaryContact) {
                                                    setPrimaryContactDraft(getEmptyPrimaryContactDraft());
                                                    setValidationErrors((previousErrors) => ({
                                                        ...previousErrors,
                                                        primarycontactid: "",
                                                        primaryContact_firstName: "",
                                                        primaryContact_lastName: "",
                                                        primaryContact_emailaddress1: "",
                                                        primaryContact_telephoneNumber: ""
                                                    }));
                                                }
                                            }}
                                        />
                                        <label htmlFor="createPrimaryContact" style={{ marginBottom: 0, fontWeight: "bold" }}>Create Primary Contact</label>
                                    </div>

                                    {showCreatePrimaryContactSection && (
                                        <>
                                            <h4 style={sectionTitleStyle}>Primary Contact</h4>
                                            {renderValidationError("primarycontactid")}
                                    <div style={sectionGridStyle}>
                                        <div>
                                            <label style={{ display: "block", marginBottom: "4px" }}>First Name {renderRequiredAsterisk()}</label>
                                            <Input
                                                disabled={isAccountCreateDetailsDisabled()}
                                                value={primaryContactDraft.firstName}
                                                onChange={(e) => handlePrimaryContactDraftChange("firstName", e.value)}
                                            />
                                            {renderValidationError("primaryContact_firstName")}
                                        </div>

                                        <div>
                                            <label style={{ display: "block", marginBottom: "4px" }}>Last Name {renderRequiredAsterisk()}</label>
                                            <Input
                                                disabled={isAccountCreateDetailsDisabled()}
                                                value={primaryContactDraft.lastName}
                                                onChange={(e) => handlePrimaryContactDraftChange("lastName", e.value)}
                                            />
                                            {renderValidationError("primaryContact_lastName")}
                                        </div>

                                        <div>
                                            <label style={{ display: "block", marginBottom: "4px" }}>Telephone</label>
                                            <Input
                                                disabled={isAccountCreateDetailsDisabled()}
                                                value={primaryContactDraft.telephoneNumber}
                                                onChange={(e) => handlePrimaryContactDraftChange("telephoneNumber", e.value)}
                                            />
                                            {renderValidationError("primaryContact_telephoneNumber")}
                                        </div>

                                        <div>
                                            <label style={{ display: "block", marginBottom: "4px" }}>Email {renderRequiredAsterisk()}</label>
                                            <Input
                                                disabled={isAccountCreateDetailsDisabled()}
                                                value={primaryContactDraft.emailaddress1}
                                                onChange={(e) => handlePrimaryContactDraftChange("emailaddress1", e.value)}
                                            />
                                            {renderValidationError("primaryContact_emailaddress1")}
                                        </div>

                                        <div>
                                            <label style={{ display: "block", marginBottom: "4px" }}>Street 1</label>
                                            <Input
                                                disabled={isAccountCreateDetailsDisabled()}
                                                value={primaryContactDraft.address1_line1}
                                                onChange={(e) => handlePrimaryContactDraftChange("address1_line1", e.value)}
                                            />
                                        </div>

                                        <div>
                                            <label style={{ display: "block", marginBottom: "4px" }}>Street 2</label>
                                            <Input
                                                disabled={isAccountCreateDetailsDisabled()}
                                                value={primaryContactDraft.address1_line2}
                                                onChange={(e) => handlePrimaryContactDraftChange("address1_line2", e.value)}
                                            />
                                        </div>

                                        <div>
                                            <label style={{ display: "block", marginBottom: "4px" }}>City</label>
                                            <Input
                                                disabled={isAccountCreateDetailsDisabled()}
                                                value={primaryContactDraft.address1_city}
                                                onChange={(e) => handlePrimaryContactDraftChange("address1_city", e.value)}
                                            />
                                        </div>

                                        <div>
                                            <label style={{ display: "block", marginBottom: "4px" }}>State/Province</label>
                                            <DropDownList
                                                data={usStateOptions}
                                                textField="text"
                                                dataItemKey="code"
                                                disabled={isAccountCreateDetailsDisabled()}
                                                value={getSelectedStateOption(primaryContactDraft.tt_stateprovinceid || primaryContactDraft.address1_stateorprovince)}
                                                defaultItem={{ code: "", name: "", text: "Select State/Province" }}
                                                onChange={(e) => {
                                                    const selectedStateCode = e.value?.code || "";
                                                    handlePrimaryContactDraftChange("tt_stateprovinceid", selectedStateCode);
                                                    handlePrimaryContactDraftChange("address1_stateorprovince", selectedStateCode);
                                                }}
                                            />
                                        </div>

                                        <div>
                                            <label style={{ display: "block", marginBottom: "4px" }}>Postal Code</label>
                                            <Input
                                                disabled={isAccountCreateDetailsDisabled()}
                                                value={primaryContactDraft.postalcode}
                                                onChange={(e) => handlePrimaryContactDraftChange("postalcode", e.value)}
                                            />
                                        </div>

                                        <div>
                                            <label style={{ display: "block", marginBottom: "4px" }}>County</label>
                                            <Input
                                                disabled={isAccountCreateDetailsDisabled()}
                                                value={primaryContactDraft.address1_county}
                                                onChange={(e) => handlePrimaryContactDraftChange("address1_county", e.value)}
                                            />
                                        </div>
                                    </div>
                                        </>
                                    )}
                                </div>
                            )}
                        </div>

                        {isEditMode && (
                            <div>
                                <label style={{ display: "block", marginBottom: "4px" }}>Primary Contact {renderRequiredAsterisk()}</label>
                                <DropDownList
                                    data={primaryContactOptions}
                                    textField="name"
                                    dataItemKey="id"
                                    value={getSelectedContactOption(primaryContactOptions, newAccount.primarycontactid)}
                                    defaultItem={{ id: "", name: "Select Primary Contact", email: "" }}
                                    onChange={(e) => {
                                        const selectedPrimaryContactId = e.value?.id || "";
                                        handleNewAccountChange("primarycontactid", selectedPrimaryContactId);
                                        handleNewAccountChange("primarycontactname", selectedPrimaryContactId ? e.value?.name || "" : "");
                                        handleNewAccountChange("schoolemailaddress", selectedPrimaryContactId ? e.value?.email || "" : "");
                                        handleNewAccountChange("emailaddress1", selectedPrimaryContactId ? e.value?.email || "" : "");
                                    }}
                                />
                                {renderValidationError("primarycontactid")}
                            </div>
                        )}
                    </div>

                    {isEditMode && (
                        <div
                            style={{
                                marginTop: "16px",
                                marginBottom: "16px",
                                width: "100%",
                                display: "flex",
                                justifyContent: "center"
                            }}
                        >
                            <div
                                style={{
                                    width: `${contactGridWidth + 130}px`,
                                    maxWidth: "100%",
                                    overflowX: "auto"
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        marginBottom: "8px",
                                        width: `${contactGridWidth + 130}px`,
                                        maxWidth: "100%"
                                    }}
                                >
                                    <h4 style={{ margin: 0 }}>Contacts</h4>
                                    <span
                                        title="Add Contact"
                                        onClick={openAddAccountContactDialog}
                                        onMouseEnter={handleToolbarButtonMouseEnter}
                                        onMouseLeave={handleToolbarButtonMouseLeave}
                                        style={{
                                            ...toolbarButtonStyle,
                                            marginLeft: "auto",
                                            marginBottom: "0"
                                        }}
                                    >
                                        <span>Add Contact</span>
                                        <AccountCircle style={toolbarIconStyle} />
                                    </span>
                                </div>
                                <Grid
                                    data={accountContacts}
                                    sortable={true}
                                    resizable={true}
                                    style={{ width: `${contactGridWidth + 130}px` }}
                                >
                                    <GridNoRecords>
                                        No contacts available
                                    </GridNoRecords>
                                    {renderContactColumns()}
                                    <Column cell={ContactEditCommandCell} width="60" title="Edit" sortable={false} />
                                    <Column cell={ContactDeleteCommandCell} width="70" title="Delete" sortable={false} />
                                </Grid>
                            </div>
                        </div>
                    )}

                    <div style={{ width: "20%", display: "flex", gap: "4px" }}>
                        <Button onClick={closeAddAccountDialog}>Cancel</Button>
                        <Button themeColor="primary" onClick={saveNewAccount}>{isEditMode ? "Update" : "Add Account"}</Button>
                    </div>
                </Dialog>
            )}

            {showContactDialog && (
                <ContactModal
                    isOpen={showContactDialog}
                    isEditMode={isContactEditMode}
                    initialContact={newContact}
                    editingContactItem={editingContactItem}
                    parentCustomerId={getCurrentEditingAccountId()}
                    onClose={closeAccountContactDialog}
                    onSaveSuccess={handleAccountContactSaved}
                    onLoaderRaise={props.onLoaderRaise}
                />
            )}
            {deleteContactDialogOpen && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        zIndex: 12000,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        pointerEvents: "none"
                    }}
                >
                    <div
                        style={{
                            width: "360px",
                            backgroundColor: "#ffffff",
                            border: "1px solid #d9d9d9",
                            borderRadius: "6px",
                            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.25)",
                            pointerEvents: "auto"
                        }}
                    >
                        <div
                            style={{
                                padding: "10px 14px",
                                borderBottom: "1px solid #e5e5e5",
                                fontWeight: "bold",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between"
                            }}
                        >
                            <span>Confirm Remove</span>
                            <button
                                type="button"
                                onClick={closeDeleteContactDialog}
                                style={{
                                    border: "none",
                                    backgroundColor: "transparent",
                                    cursor: "pointer",
                                    fontSize: "18px",
                                    lineHeight: "18px"
                                }}
                            >
                                ×
                            </button>
                        </div>
                        <div style={{ padding: "14px" }}>
                            Are you sure you want to remove this contact from this account?
                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: "8px",
                                padding: "10px 14px",
                                borderTop: "1px solid #e5e5e5"
                            }}
                        >
                            <Button onClick={closeDeleteContactDialog}>Cancel</Button>
                            <Button themeColor="error" onClick={confirmDeleteAccountContact}>Remove</Button>
                        </div>
                    </div>
                </div>
            )}
            <GridPDFExport ref={(pdfExport) => (gridPDFExport = pdfExport)}>
                {renderAccountColumns()}
                {grid}
            </GridPDFExport>
            <ExcelExport data={data} ref={(exporter) => { _export = exporter; }}>
                {renderAccountColumns()}
            </ExcelExport>
        </div>
    );
};
export default Account;
